import type {
  BoxProps,
  ImageProps as ChakraImageProps,
} from '@chakra-ui/react';
import { Box } from '@chakra-ui/react';
import * as CSS from 'csstype';
import { ImageProps as NextImageProps } from 'next/image';
import { ComponentType, FC } from 'react';

type ImageProps = {
  as: ComponentType<ChakraImageProps | NextImageProps | any>;
  objectFit?: CSS.Property.ObjectFit;
} & NextImageProps &
  Omit<BoxProps, 'as'>;

/**
 * Responsive image component for Next.js Chakra.
 * Fallback to Chakra default image component.
 */
const Image: FC<ImageProps> = ({
  as: ImgComponent,
  src,
  alt,
  objectFit = 'cover',
  ...rest
}) => {
  return (
    <Box position="relative" {...rest}>
      <ImgComponent src={src} alt={alt} style={{ objectFit }} fill />
    </Box>
  );
};

export { Image };
